/**
 * External Dependencies
 */

/**
 * Locomotive scroll
 */
import locomotive from './modules/locomotive';

/**
 * Modules
 */
import handleMenuAccordion from './modules/handleMenuAccordion';
import handleMobileNav from './modules/handleMobileNav';
import handleNav from './modules/handleNav';
import handleResponsiveVideo from './modules/handleResponsiveVideo';
import handleHeroVideo from './modules/handleHeroVideo';
import handleSwapImg from './modules/handleSwapImg';
// import handleMagneticButton from './modules/handleMagneticButton';
import handleVideoPoster from './modules/handleVideoPoster';
import handleShowMore from './modules/handleShowMore';
import handleProductShowMore from './modules/handleProductShowMore';
import handleCatMenu from './modules/handleCatMenu';
import handleSelect from './modules/handleSelect';
import handleGridChange from './modules/handleGridChange';
import handleModal from './modules/handleModal';
import handleRecipeFilter from './modules/handleRecipeFilter';
import handleBlogFilter from './modules/handleBlogFilter';
import handleNewsDrag from './modules/handleNewsDrag';
import handleParallax from './modules/handleParallax';
import handleCounter from './modules/handleCounter';
import handleContactMap from './modules/handleContactMap';
import handleContactRepeater from './modules/handleContactRepeater';
import handleContactForm from './modules/handleContactForm';
import handleProductsNav from './modules/handleProductsNav';
import handleViewportHeight from './modules/handleViewportHeight';
import handleTextSlider from './modules/handleTextSlider';
import handleGlightbox from './modules/handleGlightbox';
import handleShuffle from './modules/handleShuffle';
import handleMobileStickySection from './modules/handleMobileStickySection';
import handleStickySection from './modules/handleStickySection';
import handleStickyCircleSection from './modules/handleStickyCircleSection';
import handleIconsShowMore from './modules/handleIconsShowMore';
import handleMulitLocContactMap from './modules/handleMulitLocContactMap';
import handleLazyLoadingProducts from './modules/handleLazyLoadingProducts';
import handleNavigateHash from './modules/handleNavigateHash';
import handleBackToTop from './modules/handleBackToTop';
import handlePopup from './modules/handlePopup';
import handleVideoGallery from './modules/handleVideoGallery';

/**
 * Sliders
 */
import seedsSlider from './sliders/seedsSlider';
import productsSlider from './sliders/productsSlider';
import instagramSlider from './sliders/instagramSlider';
import recipesSlider from './sliders/recipesSlider';
import marqueeSlider from './sliders/marqueeSlider';
import archiveRecipesSlider from './sliders/archiveRecipesSlider';
import gallerySlider from './sliders/gallerySlider';
import heroAltSlider from './sliders/heroAltSlider';
import referenceSlider from './sliders/referenceSlider';
import videoSlider from './sliders/videoSlider';
import handleReferenceSlider from './modules/handleReferenceSlider';
import handleStatementOverlay from './modules/handleStatementOverlay';
import { handleGalleryDetails } from './modules/handleGalleryDetails';

/**
 * handle Three JS only on product page
 */
const three = async () => {
  if (document.body.classList.contains('single-products')) {
    await import(
      /* webpackChunkName: "handleThree" */
      './three/handleThree'
    );
  }
};

document.addEventListener('DOMContentLoaded', () => {
  handleMobileStickySection();

  const scroll = locomotive();

  /**
   * Modules
   */
  handleNav();
  handleProductsNav();
  handleMobileNav();
  handleMenuAccordion();
  handleResponsiveVideo();
  handleHeroVideo();
  handleSwapImg();
  // handleMagneticButton();
  handleVideoPoster();
  handleShowMore();
  handleProductShowMore();
  handleCatMenu();
  handleSelect();
  handleGridChange();
  handleModal();
  handleIconsShowMore();
  handleNavigateHash();
  handleRecipeFilter();
  handleBlogFilter();
  handleNewsDrag();
  handleParallax();
  handleCounter();
  handleContactMap();
  handleContactRepeater();
  handleContactForm();
  handleViewportHeight();
  handleTextSlider();
  handleGlightbox();
  handleShuffle();
  handleStickySection();
  handleStickyCircleSection();
  handleMulitLocContactMap();
  handleLazyLoadingProducts();
  handleBackToTop();
  handlePopup();
  handleVideoGallery();
  handleStatementOverlay(scroll);
  handleGalleryDetails(scroll);


  /**
   * Sliders
   */
  seedsSlider();
  productsSlider();
  instagramSlider();
  recipesSlider();
  marqueeSlider();
  archiveRecipesSlider();
  gallerySlider();
  referenceSlider();
  handleReferenceSlider();
  heroAltSlider();
  videoSlider();

  three();

  setTimeout(() => {
    scroll.update();
  }, 0);
});
